export const DEFAULT_MAX_INPUT_LENGTH = 250

export const DEFAULT_MAX_TEXTAREA_LENGTH = 500